import govukFrontendDetails from './govuk-frontend-details.mjs'

govukFrontendDetails()
